import { useTranslate } from 'react-admin';
import Dashboard from '@/components/common/dashboard/dashboard';
import { Avatar } from '@/utils/types';

interface Props {
    params: any;
    clientOrSite: 'client' | 'site' | 'place';
    avatar: Avatar;
}

const ContractualMaintenanceDashboard = ({ params, clientOrSite, avatar }: Props) => {
    const translate = useTranslate();

    return (
        <Dashboard
            title={translate('site.dashboards.contractual_maintenance')}
            leftLabel={translate('site.dashboards.planned')}
            rightLabel={translate('site.dashboards.carried_out')}
            params={params}
            interType={'preventive'}
            clientOrSite={clientOrSite}
            avatar={avatar}
        />
    );
};

export default ContractualMaintenanceDashboard;
